import { apiGet } from '../../../core/utils/api/generic'
import { ApiSearchType, SearchApiPaginatedResponse } from '../SearchTypes'

const ApiSearchService = async <T>({ entity, queryFilters }: ApiSearchType): Promise<SearchApiPaginatedResponse<T>> =>
  apiGet(`/search/${entity}`, { ...queryFilters }, 'repeat')
export default ApiSearchService
